export default __webpack_public_path__ + "static/media/dropdown.ae3e8b30.svg";